import React from "react";
import Workbook from "react-excel-workbook";

const ExcelExport = ({ filename, orders , factor }) => {
    return (
        <div className="excel-export-container">
            <Workbook
                filename={filename}
                element={
                    <button className="btn btn-success">
                        <span>دریافت خروجی اکسل</span>
                    </button>
                }
            >

                    <Workbook.Sheet data={orders} name="orders">
                        <Workbook.Column label="شناسه" value={row => row.id }/>
                        <Workbook.Column label="مبلغ" value={row => row.price} />
                        <Workbook.Column label="شناسه محصول" value={row => row.product_id} />
                        <Workbook.Column label="سایز محصول" value={row => row.variant.attributeValue} />
                        <Workbook.Column label="برند محصول" value={row => row.product.brandName} />
                        <Workbook.Column label="لینک محصول" value={row => row.product.trendyolUrl} />
                        <Workbook.Column label="وضعیت" value={row => row.status.name} />
                    </Workbook.Sheet>

                <Workbook.Sheet data={factor} name="factor">
                    <Workbook.Column label="شناسه فاکتور" value={factor.id }/>
                    <Workbook.Column label="تعداد محصول" value={factor => factor.number_of_products }/>
                    <Workbook.Column label="مبلغ کل (لیر)" value={factor => factor.total_price_lir} />
                </Workbook.Sheet>

                {/*{worksheets.map(({ name, columns, data }) => {*/}
                {/*    return (*/}
                {/*        <Workbook.Sheet name={name} data={data}>*/}
                {/*            {columns.map(({ label, value }) => {*/}
                {/*                return <Workbook.Column label={label} value={value} />;*/}
                {/*            })}*/}
                {/*        </Workbook.Sheet>*/}
                {/*    );*/}
                {/*})}*/}
            </Workbook>
        </div>
    );
};

export default ExcelExport;

ExcelExport.defaultProps = {
    filename: "",
    orders: [],
    factor: []
};
